// Actions
export const TRACK_FETCH  = '[Track] Fetch'

// Mutations
export const TRACK_META   = '[Track] meta'
export const TRACK_SAMPLE   = '[Track] sample'
export const TRACK_OBTAIN = '[Track] obtain'
export const TRACK_CLEAR  = '[Track] clear'
export const TRACK_SET_LOADING = '[Track] set loading'
